import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly apiUrl = `${environment.apiUrl}/auth`;

  private readonly accessTokenKey = 'mensa_access_token';
  private readonly userKey = 'mensa_user';

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  sendAdminOtp(email: string): Observable<any> {

    return this.http.post(
      `${this.apiUrl}/send-otp`,
      {
        email
      }
    );
  }

  verifyAdminOtp(
    email: string,
    otp: string
  ): Observable<any> {

    return this.http.post(
      `${this.apiUrl}/verify-otp`,
      {
        email,
        otp
      }
    );
  }

  setSession(response: any): void {

    sessionStorage.setItem(
      this.accessTokenKey,
      response.accessToken
    );

    sessionStorage.setItem(
      this.userKey,
      JSON.stringify(response.user)
    );
  }

  getAccessToken(): string | null {

    return sessionStorage.getItem(
      this.accessTokenKey
    );
  }

  getUser(): any {

    const user =
      sessionStorage.getItem(
        this.userKey
      );

    return user
      ? JSON.parse(user)
      : null;
  }

  isLoggedIn(): boolean {

    return !!this.getAccessToken();
  }

  hasRole(role: string): boolean {

    const user = this.getUser();

    return user?.roles?.includes(role) ?? false;
  }

  logout(): void {

    sessionStorage.removeItem(
      this.accessTokenKey
    );

    sessionStorage.removeItem(
      this.userKey
    );

    this.router.navigate(['/login']);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CandidateSessionService {

  private readonly tokenKey =
    'mensa_candidate_access_token';

  private readonly candidateKey =
    'mensa_candidate';

  setSession(
    accessToken: string,
    candidate?: any
  ): void {

    sessionStorage.setItem(
      this.tokenKey,
      accessToken
    );

    if (candidate) {
      sessionStorage.setItem(
        this.candidateKey,
        JSON.stringify(candidate)
      );
    }
  }

  getAccessToken(): string | null {

    return sessionStorage.getItem(
      this.tokenKey
    );
  }

  getCandidate(): any {

    const value =
      sessionStorage.getItem(
        this.candidateKey
      );

    return value
      ? JSON.parse(value)
      : null;
  }

  isAuthenticated(): boolean {

    return !!this.getAccessToken();
  }

  clearSession(): void {

    sessionStorage.removeItem(
      this.tokenKey
    );

    sessionStorage.removeItem(
      this.candidateKey
    );
  }
}
